import RouteResetController from 'donor-elf-web/lib/route-reset-controller';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validateNumber } from 'ember-changeset-validations/validators';
import { get, set } from '@ember/object';
import { service } from '@ember/service';

const overallGoalValidation = {
  overallGoal: validateNumber({
    gt: 0,
    integer: true,
    allowBlank: false,
    message: 'Must be a positive whole number',
  }),
};
const intervalGoalValidation = {
  intervalGoal: validateNumber({
    gte: 0,
    allowBlank: true,
    message: 'Must be a positive whole number or blank',
  }),
};

export default RouteResetController.extend({
  abilities: service(),
  coachingService: service(),
  navbarSettings: service(),

  beforeModel(transition) {
    if (this.abilities.noCoachingAbility('edit_goal')) {
      transition.abort();
    }
    set(this, 'navbarSettings.title', 'Edit Goal');
  },

  model(params) {
    let individualRecord = this.modelFor(
      'coaching.individuals.individual',
    ).record;
    let fieldSectionAndIndex = get(
      individualRecord,
      `fieldsSectionAndIndex.${params.fieldId}`,
    );
    let field = get(individualRecord, 'sections')[
      fieldSectionAndIndex.sectionIndex
    ]['fields'][fieldSectionAndIndex.fieldIndex];

    let editFieldModel = {};
    let validation = null;
    if (get(this, 'coachingService.overallGoalTypes')[get(field, 't')]) {
      editFieldModel.overallGoal = get(field, 'overallGoal');
      editFieldModel.intervalGoal = get(field, 'intervalGoal.low');
      validation = overallGoalValidation;
    } else {
      editFieldModel.intervalGoal = get(field, 'intervalGoal.low');
      validation = intervalGoalValidation;
    }
    let changeset = new Changeset(
      editFieldModel,
      lookupValidator(validation),
      validation,
    );

    return {
      individualRecord,
      fieldSectionAndIndex,
      field,
      changeset,
    };
  },
});
